import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGlobalState } from '../contexts/GlobalContext';
import UserDetails from '../Components/UserDetails';
import AddTaskForm from '../Components/AddTaskForm';
import EditUserForm from '../Components/EditUserForm';

function User() {
  const { id } = useParams(); 
  const { state } = useGlobalState();
  const navigate = useNavigate();

  
  const user = state.contacts.find((contact) => String(contact.id) === String(id));
  // Get user from Global Context
  



  const [isEditing, setIsEditing] = useState(false);
  const [userData, setUserData] = useState(user);  // ✅ Fix: Prevent infinite state updates

  useEffect(() => {
    setUserData(user);
  }, [user]);

  const handleAddTask = (newTask) => {
    setUserData((prevUser) => ({
      ...prevUser,
      tasks: [...(prevUser.tasks || []), newTask], // ✅ Ensure `tasks` is always an array
    }));
  };

  const handleSave = (updatedUserData) => {
    setUserData(updatedUserData);
    setIsEditing(false);
  };

  if (!user.id) {
    return <p>Error: No contact found with ID {id}</p>;
  }

  return (
    <div>
      <button className="btn btn-light mt-2" onClick={() => navigate(-1)}>
        &larr; Back
      </button>

      {isEditing ? (
        <EditUserForm userData={userData} onSave={handleSave} />
      ) : (
        <>
          <button className="btn btn-secondary mt-2" onClick={() => setIsEditing(true)}>Edit</button>
          <UserDetails userData={{ ...userData }} setUserData={setUserData}  />
          <AddTaskForm onAddTask={handleAddTask} contactId={user.id} />
        </>
      )}
    </div>
  );
}

export default User;
